/**
 * Round a raw FX-converted amount to a charm price (.99 / .49 endings).
 * USD amounts pass through unchanged (base catalog is already psychologically priced).
 */
export function psychologicalRound(rawConverted: number): number {
  if (!Number.isFinite(rawConverted) || rawConverted <= 0) return 0
  // Charm endings break sub-$1 SKUs (e.g. $0.30 → €0.28 should not become €0.99).
  if (rawConverted < 1) {
    return Math.round(rawConverted * 100) / 100
  }

  const maxD = Math.min(Math.ceil(rawConverted) + 3, 999)
  const charms: number[] = []
  for (let d = 0; d <= maxD; d++) {
    charms.push(d + 0.99)
    if (d >= 1) charms.push(d + 0.49)
  }

  const minAccept = rawConverted * 0.96
  const maxAccept = rawConverted * 1.22
  const valid = charms.filter((c) => c >= minAccept && c <= maxAccept)
  if (valid.length === 0) {
    const d = Math.floor(rawConverted)
    return d + 0.99
  }

  const prefer99 = valid.filter((c) => Math.abs((c % 1) - 0.99) < 0.001)
  const pool = prefer99.length ? prefer99 : valid
  return Math.min(...pool)
}
